import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Slider from 'react-slick';
import { UNIFIED_FEED_DOMAIN_SERVICE, TOI_IMAGE_DOMAIN } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import Cookie from 'utils/cookies';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './WhoIsThatGame.scss';
import GameOverlay from '../GameOverlay/GameOverlay';
import AutoSearch from '../AutoSearch/AutoSearch';
import CustomKeyBoard from '../CustomKeyBoard/CustomKeyBoard';
import { loadSyncUp, loadWhosThatStateSave } from '../../../redux';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import PracticeCard from '../PracticeCard/PracticeCard';
import Image from '../../../../../components/Image';
import MoreOnGames from '../MoreOnGames/MoreOnGames';

const WhoIsThatGame = props => {
  const {
    puzzleAPI,
    isMobile,
    userData,
    todaysGame,
    buttonClicked,
    handleGameCallback,
  } = props;

  const gameType = 'whos-that';
  const gameId = puzzleAPI && puzzleAPI.gameId ? puzzleAPI.gameId : '';
  const jsonUrl = puzzleAPI && puzzleAPI.url ? puzzleAPI.url : '';
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  const commonTranslations = _get(
    props,
    'gamesconfigData.translations.commonTranslations',
    {},
  );
  const gameSpecificTranslations = _get(
    props,
    'gamesconfigData.translations.gameSpecificTranslations.whosThat',
    {},
  );

  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [showLoader, setLoader] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [showCongrate, setCongrate] = useState(false);
  const [puzzleData, setPuzzle] = useState([]);
  const [activeRound, setActiveRound] = useState(1);
  const [hasSynced, setHasSynced] = useState(false);
  const [showIncorrectAnswer, setShowIncorrectAnswer] = useState(false);
  const [showScoreAnimation, setShowScoreAnimation] = useState(false);
  const [activeHint, setActiveHint] = useState(1);
  const [revealedHints, setRevealedHints] = useState({});
  const [gameStateData, setGameStateData] = useState([]);
  const [playAgainCheck, setPlayAgainCheck] = useState(() => {
    let playAgainCheckTemp = false;
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      playAgainCheckTemp =
        toigames.playagain && toigames.playagain.includes(gameId);
    }
    return playAgainCheckTemp;
  });
  const [isManualNavigation, setIsManualNavigation] = useState(false);
  const [isNavigationCooling, setIsNavigationCooling] = useState(false);
  const [isHintCooling, setIsHintCooling] = useState(false);

  const isManualNavigationRef = useRef(false);
  const userDataRef = useRef(userData);
  const sliderRef = useRef(null);
  const autoSearchRef = useRef(null);
  const hintSliderRef = useRef(null);
  const activeRoundRef = useRef(activeRound);
  const autoSubmitRef = useRef(null);

  const fireGa4 = (ga4Type, ga4Category, ga4Label, event, ga4SubLabel) => {
    analyticsWrapper('ga4', {
      event: event || 'user_click_games',
      type: ga4Type || '',
      category: ga4Category || '',
      label: ga4Label || '',
      sublabel: ga4SubLabel || '',
    });
    analyticsWrapper('grx', 'track', event || 'user_click_games', {
      event: event || 'user_click_games',
      type: ga4Type || '',
      category: ga4Category || '',
      label: ga4Label || '',
      sublabel: ga4SubLabel || '',
    });
  };
  const fireGaGameScreen = () => {
    analyticsWrapper('ga4', {
      event: 'user_shown_games',
      type: 'gameplay_screen',
    });
    analyticsWrapper('grx', 'track', 'user_shown_games', {
      event: 'user_shown_games',
      type: 'gameplay_screen',
    });
  };

  const overlayCall = popuptype => {
    setShowOverlay(true);
    setPopUpType(popuptype);
    let ga4Type;
    if (popuptype === 'perfectPointsGuessed') {
      ga4Type = 'max_score';
    } else if (popuptype === 'maxGuessExhausted') {
      ga4Type = 'all_guess_complete';
    }
    if (ga4Type) {
      fireGa4(ga4Type, 'game', '', 'user_shown_games');
    }
  };

  const gameStateSaveCall = () => {
    if (
      typeof props.loadWhosThatStateSave === 'function' &&
      userData?.isLoggedIn &&
      todaysGame &&
      !playAgainCheck
    ) {
      const locatStateData = JSON.parse(
        localStorage.getItem(`tilwhoisthat:${gameId}`),
      );
      try {
        const params = {
          gameId,
          gameType: 'whos-that',
          grxId,
          ssoId,
          locatStateData,
        };
        props.loadWhosThatStateSave(params);
      } catch (e) {
        console.log('game error>>', e);
      }
    }
  };

  const initGame = (savedState, puzzleDataTemp) => {
    if (savedState && buttonClicked !== 'startOver') {
      const localStateData =
        savedState && Array.isArray(savedState)
          ? savedState
          : JSON.parse(savedState);
      setGameStateData(localStateData);

      const firstIncompleteRoundIndex = localStateData.findIndex(
        round => !round.isRoundCompleted,
      );

      if (firstIncompleteRoundIndex !== -1) {
        const newActiveRound = firstIncompleteRoundIndex + 1;
        setActiveRound(newActiveRound);
        activeRoundRef.current = newActiveRound;

        setTimeout(() => {
          if (sliderRef && sliderRef.current && sliderRef.current.slickGoTo) {
            sliderRef.current.slickGoTo(firstIncompleteRoundIndex);
          }
        }, 100);
      }
    } else {
      const gameStateDataTemp = puzzleDataTemp?.roundsInfo?.map(() => ({
        score: 0,
        penalty: 0,
        remainingChances: 6,
        isRevealed: false,
        isRoundCompleted: false,
      }));
      setGameStateData(gameStateDataTemp);
      setActiveRound(1);
      activeRoundRef.current = 1;
    }
  };

  const gameStateFetchCall = puzzleDataTemp => {
    if (
      userData?.isLoggedIn &&
      todaysGame &&
      !showCongrate &&
      !playAgainCheck
    ) {
      const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/get/paused/game?pc=toi&pfm=web&gameId=${gameId}&gameType=whos_that`;
      makeRequest
        .post(url, {}, { headers: { grxId, ssoId } })
        .then(data => {
          const serverSavedState = data?.data?.stateWhosThat?.whosThatData;
          initGame(serverSavedState, puzzleDataTemp);
          setLoader(false);
        })
        .catch(err => {
          console.log(err);
          overlayCall('errorPopUp');
          setLoader(false);
        });
    } else {
      const savedState = localStorage.getItem(`tilwhoisthat:${gameId}`);
      initGame(savedState, puzzleDataTemp);
    }
  };

  const clearLocalStorage = key => {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  const clearPlayAgain = () => {
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      let playagainArray = toigames.playagain && toigames.playagain.split(',');
      if (playagainArray && playagainArray.includes(gameId)) {
        playagainArray = playagainArray.filter(id => id !== gameId);
        toigames.playagain = playagainArray.join(',');
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
  };

  const getStatusCall = puzzleDataTemp => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/status/game?pc=toi&pfm=web&gameId=${gameId}&gameType=whos_that`;
    const requestParams = { params: {}, headers: { grxId, ssoId } };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        try {
          if (
            data &&
            data.data &&
            data.data.hasPlayed &&
            data.data.items &&
            Array.isArray(data.data.items) &&
            !playAgainCheck
          ) {
            const gameCongratulationsData = data?.data?.items?.find(
              item => item?.tn === 'gameCongratulationsData',
            );
            if (gameCongratulationsData?.gameCongratulationsData) {
              setGameStateData(
                data?.data?.stateWhosThat?.whosThatData?.roundsInfo,
              );
              setResultData(gameCongratulationsData?.gameCongratulationsData);
            }
            setCongrate(true);
            setLoader(false);
            clearLocalStorage(`tilwhoisthat:${gameId}`);
            fireGaGameScreen();
            return;
          }

          if (playAgainCheck) {
            clearPlayAgain(gameId);
            clearLocalStorage(`tilwhoisthat:${gameId}`);
          }
          gameStateFetchCall(puzzleDataTemp);
        } catch (error) {
          console.error('error inside game js >>', error);
        }
        setLoader(false);
        fireGaGameScreen();
      })
      .catch(err => {
        console.log(err);
        overlayCall('errorPopUp');
        setLoader(false);
        fireGaGameScreen();
      });
  };

  const getGameJsonCall = () => {
    makeRequest
      .get(jsonUrl, {}, 'skipfeedengine')
      .then(data => {
        const puzzleDataTemp = data?.data;
        setPuzzle(puzzleDataTemp);
        getStatusCall(puzzleDataTemp);
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        overlayCall('errorPopUp');
        setLoader(false);
      });
  };

  useEffect(() => {
    getGameJsonCall();
  }, []);

  const gameSyncCall = () => {
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const params = {
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  const gameSubmitCall = () => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/submit/game?pc=toi&pfm=web&fv=1250&gameId=${gameId}&gameType=whos_that`;
    const gameStateDataTemp =
      JSON.parse(localStorage.getItem(`tilwhoisthat:${gameId}`)) ||
      puzzleData.roundsInfo;
    const totalScore = gameStateDataTemp
      ? gameStateDataTemp.reduce((sum, round) => sum + (round.score || 0), 0)
      : 0;

    const roundsInfo = gameStateDataTemp.map((roundState, index) => {
      const roundInfo = puzzleData.roundsInfo[index];
      return {
        playerNumber: roundInfo.playerNumber,
        teamName: roundInfo.teamName,
        jerseyImageUrl: roundInfo.jerseyImageUrl,
        jerseyTextColor: roundInfo.jerseyTextColor || '',
        playerName: roundInfo.playerName,
        score: roundState.score || 0,
        penalty: roundState.penalty || 0,
        remainingChances: roundState.remainingChances,
        isRevealed: roundState.isRevealed || false,
        isRoundCompleted: true,
      };
    });
    setGameStateData(roundsInfo);

    const postData = {
      totalScore,
      whosThatData: {
        backgroundImageUrl: puzzleData.backgroundImageUrl || '',
        abbrevationText: puzzleData.abbrevationText || '',
        roundsInfo,
      },
    };
    setLoader(true);
    makeRequest
      .post(url, postData, { headers: { grxId, ssoId } })
      .then(data => {
        if (data?.data?.items) {
          setPlayAgainCheck(false);
          const gameCongratulationsData = data?.data?.items?.find(
            item => item?.tn === 'gameCongratulationsData',
          );
          if (gameCongratulationsData?.gameCongratulationsData) {
            setResultData(gameCongratulationsData?.gameCongratulationsData);
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setCongrate(true);
          setLoader(false);
        }
        setLoader(false);
        clearLocalStorage(`tilwhoisthat:${gameId}`);
      })
      .catch(err => {
        console.error(err);
        overlayCall('errorPopUp');
        setLoader(false);
      });
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData && userData.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  const submitConfirmation = () => {
    fireGa4('submit_game', 'game', 'N/A');
    if (!autoSubmitRef.current) {
      overlayCall('submitWhoIsThat');
    }
  };

  const submit = () => {
    gameSubmitCall();
  };

  const howtoPlay = () => {
    overlayCall('howToPlayWhoIsThat');
    fireGa4('how_to_play', 'game');
  };

  const hardPause = () => {
    handleGameCallback();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fireGa4('pause', 'game');
  };

  const checkAllRoundsCompleted = () => {
    if (!gameStateData || !puzzleData?.roundsInfo) return false;

    const allCompleted = gameStateData.every(round => round.isRoundCompleted);
    const totalRounds = puzzleData.roundsInfo.length;

    return allCompleted && gameStateData.length === totalRounds;
  };

  const next = (scrollType = 'auto') => {
    if (isNavigationCooling) return;

    setIsNavigationCooling(true);
    setTimeout(() => {
      setIsNavigationCooling(false);
    }, 1000);

    setShowScoreAnimation(false);
    const maxRounds = puzzleData?.roundsInfo?.length || 0;

    if (checkAllRoundsCompleted() && !showCongrate) {
      fireGa4('submit_game', 'game', 'auto-submitted');
      gameSubmitCall();
      return;
    }

    if (activeRoundRef.current < maxRounds) {
      setActiveRound(activeRound + 1);
      activeRoundRef.current += 1;
      sliderRef.current.slickNext();
      sliderRef.current.slickNext();
    } else if (activeRoundRef.current === maxRounds && scrollType === 'auto') {
      const incompleteRound = gameStateData.findIndex(
        round => !round.isRoundCompleted,
      );

      if (incompleteRound !== -1) {
        setActiveRound(incompleteRound + 1);
        activeRoundRef.current = incompleteRound + 1;
        sliderRef.current.slickGoTo(incompleteRound);
      } else if (!showCongrate) {
        fireGa4('submit_game', 'game', 'auto-submitted');
        gameSubmitCall();
      }
    }
    if (scrollType === 'manualscroll') {
      isManualNavigationRef.current = false;
      setIsManualNavigation(false);
    }
  };

  const previous = () => {
    if (isNavigationCooling) return;

    setIsNavigationCooling(true);
    setTimeout(() => {
      setIsNavigationCooling(false);
    }, 1000);

    setShowScoreAnimation(false);
    if (activeRound > 1) {
      setActiveRound(activeRound - 1);
      activeRoundRef.current -= 1;
      sliderRef.current.slickPrev();
    }
  };

  function NextArrow(propsArrow) {
    const { onClick } = propsArrow;
    const isLastRound =
      activeRoundRef.current === (puzzleData?.roundsInfo?.length || 0);

    const isDisabled = isNavigationCooling || isLastRound;

    return (
      <div
        className={`${s.arrow} ${s.arrowNext} ${isDisabled ? s.disable : ''}`}
        onClick={() => {
          if (!isDisabled && onClick) {
            isManualNavigationRef.current = true;
            setIsManualNavigation(true);
            next('manualscroll');
          }
        }}
      >
        <i className={`${s.iplGameSprite} ${s.rightIcon}`} />
      </div>
    );
  }

  function PrevArrow(propsData) {
    const { onClick } = propsData;
    const isFirstRound = activeRoundRef.current === 1;

    const isDisabled = isNavigationCooling || isFirstRound;

    return (
      <div
        className={`${s.arrow} ${s.arrowPrev} ${isDisabled ? s.disable : ''}`}
        onClick={() => {
          if (!isDisabled && onClick) {
            previous();
          }
        }}
      >
        <i className={`${s.iplGameSprite} ${s.leftIcon}`} />
      </div>
    );
  }

  const sliderSettings = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
  };

  const nextHint = () => {
    const currentRound = puzzleData?.roundsInfo?.[activeRound - 1] || {};
    const hints = currentRound?.hints || [];
    if (activeHint < hints.length && !isHintCooling) {
      setIsHintCooling(true);
      setTimeout(() => {
        setIsHintCooling(false);
      }, 500); // Short cooldown to prevent rapid clicks
      setActiveHint(prevHint => {
        const nextHintNumber = Math.min(prevHint + 1, hints.length);
        if (hintSliderRef.current) {
          hintSliderRef.current.slickGoTo(nextHintNumber - 1);
        }
        return nextHintNumber;
      });
    }
  };

  const previousHint = () => {
    if (activeHint > 1 && !isHintCooling) {
      setIsHintCooling(true);
      setTimeout(() => {
        setIsHintCooling(false);
      }, 500); // Short cooldown to prevent rapid clicks
      setActiveHint(prevHint => {
        const nextHintNumber = Math.max(prevHint - 1, 1);
        if (hintSliderRef.current) {
          hintSliderRef.current.slickGoTo(nextHintNumber - 1);
        }
        return nextHintNumber;
      });
    }
  };

  function NextHintArrow() {
    const currentRound = puzzleData?.roundsInfo?.[activeRound - 1] || {};
    const hints = currentRound?.hints || [];
    const isLastHint = activeHint >= hints.length || isHintCooling;

    return (
      <div
        className={`${s.hintarrow} ${s.nextIcon} ${
          isLastHint ? s.disable : ''
        }`}
        onClick={nextHint}
      >
        <i className={s.icon} />
      </div>
    );
  }

  function PrevHintArrow() {
    const isFirstHint = activeHint <= 1 || isHintCooling;
    return (
      <div
        className={`${s.hintarrow} ${s.prevIcon} ${
          isFirstHint ? s.disable : ''
        }`}
        onClick={previousHint}
      >
        <i className={s.icon} />
      </div>
    );
  }

  const hintSliderSettings = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    autoplay: false,
    nextArrow: <NextHintArrow />,
    prevArrow: <PrevHintArrow />,
  };

  useEffect(
    () => {
      setActiveHint(1);
      if (
        hintSliderRef &&
        hintSliderRef.current &&
        hintSliderRef.current.slickGoTo
      ) {
        hintSliderRef.current.slickGoTo(0);
      }
    },
    [activeRound],
  );

  useEffect(
    () => {
      if (puzzleData?.roundsInfo?.length) {
        const initialRevealedHints = {};
        puzzleData.roundsInfo.forEach((_, index) => {
          initialRevealedHints[index + 1] = 0;
        });

        const savedState = localStorage.getItem(`tilwhoisthat:${gameId}`);
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          parsedState.forEach((round, index) => {
            if (round.penalty > 0) {
              initialRevealedHints[index + 1] = Math.min(
                round.penalty / 10,
                puzzleData.roundsInfo[index].hints.length,
              );
            }
          });
        }

        setRevealedHints(initialRevealedHints);
      }
    },
    [puzzleData],
  );

  const handleGuessClick = playerName => {
    if (!playerName || !puzzleData?.roundsInfo) return;

    const currentRound = puzzleData.roundsInfo[activeRound - 1];
    if (!currentRound) return;

    const correctPlayerName = currentRound.playerName;
    if (!correctPlayerName) return;

    const normalizedGuess = playerName.toLowerCase().replace(/\s+/g, '');
    const normalizedCorrect = correctPlayerName
      .toLowerCase()
      .replace(/\s+/g, '');
    const isCorrect = normalizedGuess === normalizedCorrect;

    if (isCorrect) {
      setShowScoreAnimation(true);

      const currentRoundState = gameStateData[activeRound - 1];
      const remainingChances = currentRoundState?.remainingChances;
      const scorePerChance = 10;
      const baseScore = 50;
      const calculatedScore =
        baseScore + (remainingChances - 1) * scorePerChance;

      const updatedGameStateData = [...gameStateData];
      updatedGameStateData[activeRound - 1] = {
        ...updatedGameStateData[activeRound - 1],
        score: calculatedScore,
        isRoundCompleted: true,
      };

      setGameStateData(updatedGameStateData);
      localStorage.setItem(
        `tilwhoisthat:${gameId}`,
        JSON.stringify(updatedGameStateData),
      );

      const allCompleted = updatedGameStateData.every(
        round => round.isRoundCompleted,
      );

      if (allCompleted) {
        autoSubmitRef.current = true;
        setTimeout(() => {
          setShowScoreAnimation(false);
          fireGa4('submit_game', 'game', 'auto-submitted');
          gameSubmitCall();
          autoSubmitRef.current = false;
        }, 3000);
      } else {
        setTimeout(() => {
          setShowScoreAnimation(false);
          if (!isManualNavigationRef.current) {
            next();
          }
          isManualNavigationRef.current = false;
          setIsManualNavigation(false);
          if (autoSearchRef && autoSearchRef.current) {
            autoSearchRef.current.clearQuery();
          }
        }, 3000);
      }
      fireGa4(
        'guess_button',
        'game',
        `player_${activeRoundRef.current}`,
        'user_click_games',
        `guess_${6 - remainingChances}_correct`,
      );
      fireGa4(
        'points_scored',
        'game',
        `player_${activeRoundRef.current}`,
        'user_click_games',
        `correct_guess`,
      );
    } else {
      setShowIncorrectAnswer(true);
      const updatedGameStateData = [...gameStateData];
      const currentRoundState = updatedGameStateData[activeRound - 1];
      const newRemainingChances = Math.max(
        0,
        currentRoundState.remainingChances - 1,
      );
      const baseScore = 0;
      const isChancesExhausted = newRemainingChances === 0;

      updatedGameStateData[activeRound - 1] = {
        ...currentRoundState,
        remainingChances: newRemainingChances,
        penalty: (currentRoundState.penalty || 0) + 10,
        isRoundCompleted: isChancesExhausted
          ? true
          : currentRoundState.isRoundCompleted,
        score: isChancesExhausted ? baseScore : currentRoundState.score,
      };

      setGameStateData(updatedGameStateData);
      localStorage.setItem(
        `tilwhoisthat:${gameId}`,
        JSON.stringify(updatedGameStateData),
      );

      const currentHintsRevealed = revealedHints[activeRound] || 0;
      const totalHintsAvailable = currentRound.hints?.length || 0;

      if (currentHintsRevealed < totalHintsAvailable) {
        const newRevealedHints = { ...revealedHints };
        newRevealedHints[activeRound] = Math.min(
          currentHintsRevealed + 1,
          totalHintsAvailable,
        );
        setRevealedHints(newRevealedHints);
      }

      fireGa4(
        'guess_button',
        'game',
        `player_${activeRoundRef.current}`,
        'user_click_games',
        `guess_${6 - newRemainingChances}`,
      );

      setTimeout(() => {
        setShowIncorrectAnswer(false);
        if (autoSearchRef && autoSearchRef.current) {
          autoSearchRef.current.clearQuery();
        }

        if (isChancesExhausted) {
          const allCompleted = updatedGameStateData.every(
            round => round.isRoundCompleted,
          );
          fireGa4(
            'points_scored',
            'game',
            `player_${activeRoundRef.current}`,
            'user_click_games',
            'incorrect_guess',
          );
          if (allCompleted) {
            fireGa4('submit_game', 'game', 'auto-submitted');
            gameSubmitCall();
          } else if (!isManualNavigationRef.current) {
            next();
          }
          isManualNavigationRef.current = false;
          setIsManualNavigation(false);
        }
      }, 3000);
    }
    gameStateSaveCall();
  };

  const handleKeyPress = event => {
    if (event === 'Submit') {
      submitConfirmation();
      return;
    } else if (event === 'deleted') {
      if (autoSearchRef && autoSearchRef.current) {
        autoSearchRef.current.handleBackspace();
      }
      return;
    } else if (event === 'space') {
      if (autoSearchRef && autoSearchRef.current) {
        autoSearchRef.current.appendCharacter(' ');
      }
      return;
    }
    if (autoSearchRef && autoSearchRef.current) {
      event = isMobile ? event.toLowerCase() : event;
      autoSearchRef.current.appendCharacter(event);
    }
  };

  const handleRevealConfirmation = () => {
    overlayCall('revealWhoIsThat');
    //fireGa4('reveal', 'game', `player_${activeRound}`);
  };

  const handleReveal = check => {
    if (check && typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      toigames.revealCellPopUpWhoIsThat = true;
      localStorage.setItem('toigames', JSON.stringify(toigames));
    }
    if (gameStateData[activeRound - 1]?.isRoundCompleted) return;

    const updatedGameStateData = [...gameStateData];
    updatedGameStateData[activeRound - 1] = {
      ...updatedGameStateData[activeRound - 1],
      score: 0,
      isRevealed: true,
      isRoundCompleted: true,
      remainingChances: 0,
    };

    setGameStateData(updatedGameStateData);
    localStorage.setItem(
      `tilwhoisthat:${gameId}`,
      JSON.stringify(updatedGameStateData),
    );

    const allCompleted = updatedGameStateData.every(
      round => round.isRoundCompleted,
    );

    if (allCompleted) {
      autoSubmitRef.current = true;
      setTimeout(() => {
        fireGa4('submit_game', 'game', 'auto-submitted');
        autoSubmitRef.current = false;
        gameSubmitCall();
      }, 3000);
    } else {
      setTimeout(() => {
        if (!isManualNavigationRef.current) {
          next();
        }
        isManualNavigationRef.current = false;
        setIsManualNavigation(false);
        if (autoSearchRef && autoSearchRef.current) {
          autoSearchRef.current.clearQuery();
        }
      }, 3000);
    }
    //fireGa4('reveal_answer', 'game');
    gameStateSaveCall();
  };

  const callonContinue = (type, check) => {
    switch (type) {
      case 'submitConfirmation':
        submit();
        break;
      case 'revealCellWhoIsThat':
        handleReveal(check);
        fireGa4(
          'reveal_player',
          'game_player_reveal_popup',
          `player_${activeRoundRef.current ? activeRoundRef.current : 1}`,
          'user_click_games',
        );
        break;
      default:
        break;
    }
  };

  const manageTimer = () => {
    if (document.visibilityState === 'hidden') {
      if (!showCongrate) {
        hardPause();
      }
    }
  };

  useEffect(
    () => {
      if (typeof showCongrate !== 'undefined') {
        document.addEventListener('visibilitychange', manageTimer);
        return () => {
          document.removeEventListener('visibilitychange', manageTimer);
        };
      }
      return () => {};
    },
    [showCongrate],
  );

  const handleRoundSelection = index => {
    if (isNavigationCooling) return;
    setIsNavigationCooling(true);
    setTimeout(() => {
      setIsNavigationCooling(false);
    }, 1000);
    isManualNavigationRef.current = true;
    setIsManualNavigation(true);
    setActiveRound(index + 1);
    activeRoundRef.current = index + 1;
    if (sliderRef && sliderRef.current && sliderRef.current.slickGoTo) {
      sliderRef.current.slickGoTo(index);
      isManualNavigationRef.current = false;
      setIsManualNavigation(false);
    }
  };

  return (
    <>
      {showLoader && (
        <div className={s.loaderouter}>
          <LoaderSpinner />
        </div>
      )}
      {showOverlay && (
        <GameOverlay
          commonTranslations={commonTranslations}
          gameSpecificTranslations={gameSpecificTranslations}
          popUpType={popUpType}
          gameOverlayCallback={gameOverlayCallback}
          callonContinue={callonContinue}
          gameType={gameType}
        />
      )}
      <div
        className={`${s.stadiumWrapper} ${
          showCongrate ? s.whosCongratuationPage : ''
        } ${showScoreAnimation ? s.confettiImg : ''}`}
      >
        <div className={s.controls}>
          <div className={s.leftArea}>
            <div className={s.roundWrap}>
              <ul>
                {puzzleData &&
                  puzzleData.roundsInfo &&
                  puzzleData.roundsInfo.map((item, index) => (
                    <li
                      key={index + 1}
                      className={activeRound === index + 1 ? s.active : ' '}
                      onClick={() => handleRoundSelection(index)}
                    >
                      <div className={s.itemTop}>
                        <span>
                          {puzzleData?.abbrevationText}
                          {index + 1}
                        </span>
                      </div>
                      <div className={s.itemBottom}>
                        <strong>
                          {gameStateData[index]?.score === 0 &&
                          !gameStateData[index]?.isRoundCompleted
                            ? '-'
                            : gameStateData[index]?.score}
                        </strong>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {!showCongrate && (
            <div className={s.rightArea}>
              <div className={s.actionWrap}>
                <div
                  className={s.circle}
                  onClick={() => {
                    if (typeof localStorage !== 'undefined') {
                      const storedValue = localStorage.getItem('toigames');
                      const parsedValue = storedValue
                        ? JSON.parse(storedValue)
                        : '';
                      const revealCellPopUpWhoIsThat = parsedValue
                        ? parsedValue.revealCellPopUpWhoIsThat
                        : '';
                      if (revealCellPopUpWhoIsThat) {
                        handleReveal();
                        fireGa4(
                          'reveal_player',
                          'game',
                          `player_${activeRoundRef.current}`,
                          'user_click_games',
                          'nopopup',
                        );
                        return false;
                      }
                    }
                    handleRevealConfirmation();
                    fireGa4(
                      'reveal_player',
                      'game',
                      `player_${activeRoundRef.current}`,
                      'user_click_games',
                      'popup',
                    );
                    return false;
                  }}
                >
                  <i className={`${s.icon} ${s.reveal}`} />
                </div>
                <div
                  className={s.circle}
                  onClick={() => {
                    hardPause();
                  }}
                >
                  <i className={`${s.icon} ${s.pause}`} />
                </div>
                <div
                  className={s.circle}
                  onClick={() => {
                    howtoPlay();
                  }}
                >
                  <i className={`${s.icon} ${s.question}`} />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={s.jerseyWrapper}>
          <Slider
            ref={slider => {
              sliderRef.current = slider;
            }}
            {...sliderSettings}
            className="slick_UI"
          >
            {puzzleData &&
              puzzleData.roundsInfo &&
              puzzleData.roundsInfo.map((round, index) => (
                <div key={index} className={s.jersey}>
                  <figure>
                    <Image
                      src={
                        round.jerseyImageUrl ||
                        `${TOI_IMAGE_DOMAIN}/photo/119128323.cms`
                      }
                      placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/111258810.cms`}
                      alt="jersey"
                    />
                  </figure>
                  <div className={s.teamName}>{round.teamName || 'RCB'}</div>
                  <div className={s.jerseyNumber}>
                    {round.playerNumber || '18'}
                  </div>
                </div>
              ))}
          </Slider>

          <div className={`${s.score} ${showScoreAnimation ? 'show' : ''}`}>
            <figure>
              <Image
                src={`${TOI_IMAGE_DOMAIN}/photo/119197013.cms`}
                placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/111258810.cms`}
                alt="score"
                className={s.scoreImg}
              />
              <figcaption>
                {(gameStateData &&
                  Array.isArray(gameStateData) &&
                  gameStateData[activeRound - 1]?.score) ||
                  0}
              </figcaption>
            </figure>
          </div>
        </div>
        {gameStateData[activeRound - 1]?.isRoundCompleted && (
          <div className={s.correctAnswer}>
            <span>Correct Answer</span>
            <strong>
              {puzzleData?.roundsInfo?.[activeRound - 1]?.playerName}
            </strong>
          </div>
        )}
        {!showCongrate && (
          <div className={s.guessArea}>
            {!gameStateData[activeRound - 1]?.isRoundCompleted && (
              <AutoSearch
                ref={autoSearchRef}
                data={puzzleData ? puzzleData.playersList : []}
                text={
                  puzzleData
                    ? puzzleData.userInputTitleText
                    : 'Guess the Player'
                }
                handleGuessClick={handleGuessClick}
                showIncorrectAnswer={showIncorrectAnswer}
                isMobile={isMobile}
              />
            )}
            <div className={s.remainingHints}>
              <div className={s.remainingChances}>
                <span>Remaining chances</span>
                <ul>
                  {[...Array(6)].map((_, index) => {
                    const currentRoundState = gameStateData[activeRound - 1];
                    const remainingChances =
                      currentRoundState?.remainingChances;
                    const usedChances = 6 - remainingChances;
                    const isDisabled = index < usedChances;
                    return (
                      <li key={index}>
                        <i
                          className={`${s.iplGameSprite} ${s.iconBall} ${
                            isDisabled ? s.disable : ''
                          }`}
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className={s.hintData}>
                <Slider
                  ref={slider => {
                    hintSliderRef.current = slider;
                  }}
                  {...hintSliderSettings}
                  className="hint_slick_UI"
                >
                  {(() => {
                    if (!puzzleData?.roundsInfo?.[activeRound - 1]?.hints) {
                      return (
                        <div className={s.item}>
                          For every wrong attempt, you&apos;ll receive a hint,
                          but it will decrease your score by 10 points
                        </div>
                      );
                    }

                    return puzzleData.roundsInfo[activeRound - 1].hints.map(
                      (hint, index) => (
                        <div key={index} className={s.item}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: hint?.replace(
                                /(hint \d+:)/i,
                                '<strong>$1</strong>',
                              ),
                            }}
                          />
                        </div>
                      ),
                    );
                  })()}
                </Slider>
              </div>
            </div>
            {!isMobile && (
              <button className={`${s.submitBtn}`} onClick={submitConfirmation}>
                End Game
              </button>
            )}
            {isMobile && <CustomKeyBoard handleKeyPress={handleKeyPress} />}
          </div>
        )}
      </div>
      {showCongrate &&
        resultData && (
          <CongratulationsNew
            buttonClicked={buttonClicked}
            resultData={resultData}
            gameId={gameId}
            showCongrate={showCongrate}
            playAgainCheck={playAgainCheck}
            type={gameType}
          />
        )}
      {showCongrate && (
        <div className={s.gameCardArea}>
          <div className={s.gameWidget}>
            {/* <div className={s.practiceCard}>
              <PracticeCard gameType={gameType} isLargeCard={!isMobile} />
            </div> */}
            <MoreOnGames
              gameType="whos-that"
              isMobile
              forceLoadDataOnInit
              isCogratulationsPage
              cardProps={{ ga4Category: 'congratulations' }}
              moreOnGamesTitle="Explore More Games"
            />
          </div>
        </div>
      )}
    </>
  );
};

WhoIsThatGame.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
};

WhoIsThatGame.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadWhosThatStateSave: params => {
    dispatch(loadWhosThatStateSave(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(WhoIsThatGame);
